import { render, staticRenderFns } from "./door.vue?vue&type=template&id=24ca294a&scoped=true&"
import script from "./door.vue?vue&type=script&lang=js&"
export * from "./door.vue?vue&type=script&lang=js&"
import style0 from "./door.vue?vue&type=style&index=0&id=24ca294a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca294a",
  null
  
)

export default component.exports